// Local translations
export const T = {
  en_GB: {
    loggingOut: "Logging out...",
    signedOut: "Signed out successfully",
    redirecting: "Redirecting to login...",
  },
  nb_NO: {
    loggingOut: "Logger ut...",
    signedOut: "Logget ut",
    redirecting: "Omdirigerer til innlogging...",
  },
} as const;
